import type {
    INormalItemProps,
    TransformCartItem,
    CartItemAddon,
} from "@swiggy-private/dls-web-recipe-common-web/dist/components/FoodItem/types";
import type { ILocalCart } from "@swiggy-private/portal-dineout-context";
import type { NestedAddon, RuntimeAddon, RuntimeCartItem } from "../types/cart";

const isNestedAddon = (addon: RuntimeAddon): addon is NestedAddon =>
    "choices" in addon && Array.isArray(addon.choices);

const transformAddon = (addon: RuntimeAddon): CartItemAddon[] => {
    if (isNestedAddon(addon)) {
        return addon.choices.map((choice) => ({
            choice_id: choice.id,
            choiceId: choice.id,
            groupId: addon.groupId,
            group_id: addon.groupId,
            name: choice.name,
        }));
    }

    return [
        {
            choice_id: addon.choice_id || addon.choiceId,
            choiceId: addon.choiceId || addon.choice_id,
            groupId: addon.groupId || addon.group_id,
            group_id: addon.group_id || addon.groupId,
            name: addon.name,
        },
    ];
};

export const getCartItemFromLocalCart = (id: string | number, localCart: ILocalCart) => {
    try {
        const itemId = String(id);
        const finalCartItem: {
            items: TransformCartItem["items"];
            quantity: number;
            itemId?: number;
        } = {
            items: [],
            quantity: 0,
        };

        const runtimeCartItems = localCart.cartItems as unknown as RuntimeCartItem[];
        const cartItem = runtimeCartItems.find((item) => String(item.menu_item_id) === itemId);
        const cartItems = runtimeCartItems.filter((item) => String(item.menu_item_id) === itemId);
        if (cartItem) {
            finalCartItem.itemId = Number(cartItem.menu_item_id);
            finalCartItem.items = cartItems.map((item) => ({
                ...item,
                addons: (item.addons ?? []).flatMap(transformAddon),
                variants: item.variants ?? [],
            }));
            finalCartItem.quantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);
        }
        return finalCartItem as INormalItemProps["cartItem"];
    } catch (_) {
        // no-ops
    }
};
